exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.leo-inline-option-tip-icon[data-v-6491a444] {\r\n  margin-left: 4px;\r\n  color: #909399;\r\n  cursor: help;\r\n  font-size: 14px;\r\n  vertical-align: middle;\n}\n.leo-inline-option-tip-icon[data-v-6491a444]:hover {\r\n  color: #409eff;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6491a444","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LeoKnowledge/LeoInlineOptionTip.vue
// module id = FUTY
// module chunks = 488